var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"DataTables AssemblyDetailsComponent "},[(!_vm.isRevision)?_c('p',[_vm._v(_vm._s(_vm.lang.infotext_1))]):_vm._e(),_vm._v(" "),(!_vm.isData)?_c('LoaderComponent'):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13820a3c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/AssemblyDetailsComponent.vue
// module id = null
// module chunks = 